import { IndeedGeneralException } from './IndeedGeneralException';

export class IndeedCandidateEngagementException extends IndeedGeneralException {
  constructor(message: string) {
    super(message);
  }
}
